/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import LayoutCell from "../landing-edit/LayoutCell"
import SectionAddButton from "../landing-edit/SectionAddButton"
import SectionBottomPaddingHandler from "../landing-edit/SectionBottomPaddingHandler"
import SectionContainerHandler from "../landing-edit/SectionContainerHandler"
import SectionEditPanel from "../landing-edit/SectionEditPanel"
import SectionHeightHandler from "../landing-edit/SectionHeightHandler"
import SectionHidden from "../landing-edit/SectionHidden"
import SectionMarking from "../landing-edit/SectionMarking"
import SectionTopPaddingHandler from "../landing-edit/SectionTopPaddingHandler"
import Section from "./Section"
import SectionContainer from "./SectionContainer"
import ProportiaHandler from "../landing-edit/ProportiaHandler"

/* Protopia Ecosystem component */
export interface ISectionIsEditProps {
   section: ILandingSection
   i: number
}
const SectionIsEdit = ({i, ...props}: ISectionIsEditProps): JSX.Element => { 
    const [section, setSection] = useState<ILandingSection>(props.section)
 
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find((s) => s.id === props.section.id)!
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(( prevState ) => {  
                        return sec
                    })
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, [])  

    return section?.id 
        ?
        <SectionContainer i={ i } section={ section } key={ section.id } className="section-border-bottom">
            <>
                {
                    section.isHidden 
                        ?
                        <SectionHidden i={ i } section={ section } />
                        :
                        <Section i={ i } section={ section } containerChildren={<ProportiaHandler i={ i } section={ section } />}>
                            <>
                                <SectionMarking                 i={ i } section={ section } />   
                                <SectionContainerHandler        i={ i } section={ section } />
                                <LayoutCell                     i={ i } section={ section } />
                                
                            </>        
                        </Section>
                }
                <SectionHeightHandler           i={ i } section={ section } />
                <SectionTopPaddingHandler       i={ i } section={ section } />
                <SectionBottomPaddingHandler    i={ i } section={ section } />
                <SectionAddButton               i={ i } section={ section } />
                <SectionEditPanel               i={ i } section={ section } />                                                    
            </>
        </SectionContainer>
        :
        <></>
}
export default SectionIsEdit